import React, { Suspense, useEffect } from 'react'
import { Provider } from 'react-redux'
import { I18nextProvider, useTranslation } from 'react-i18next'
import { PersistGate } from 'redux-persist/es/integration/react'
import { Spin } from 'antd'
import { BrowserRouter } from 'react-router-dom'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'
import { QueryParamProvider } from 'use-query-params'
import queryString from 'query-string'

import 'antd/dist/reset.css'

// reducers
// eslint-disable-next-line import/no-cycle
import rootReducer from './reducers'

// utils
import configureStore from './utils/configureStore'
import i18n from './utils/i18n'

import AppRoutes from './routes/Routes'

const { store, persistor } = configureStore(rootReducer)

const App = () => {
	const { t } = useTranslation()
	// handle event from pressed backspace key
	const eventHandler = (event: KeyboardEvent) => {
		if (event.key === 'Backspace') {
			window.history.forward()
			window.onunload = null
		}
	}

	useEffect(() => {
		// prevent "go back" in browsers using backspace button
		document.addEventListener('keydown', eventHandler, false)
		return () => {
			document.removeEventListener('keydown', eventHandler, false)
		}
	}, [])

	return (
		<Suspense
			fallback={
				<div className={'loading-spinner'}>
					<Spin tip={`${t('loc:Loading')}...`} />
				</div>
			}
		>
			<I18nextProvider i18n={i18n}>
				<PersistGate
					loading={
						<div className={'loading-spinner'}>
							<Spin tip={`${t('loc:Loading')}...`} />
						</div>
					}
					persistor={persistor}
				>
					<Provider store={store}>
						<BrowserRouter>
							<QueryParamProvider
								adapter={ReactRouter6Adapter}
								options={{
									searchStringToObject: queryString.parse,
									objectToSearchString: queryString.stringify
								}}
							>
								<AppRoutes />
							</QueryParamProvider>
						</BrowserRouter>
					</Provider>
				</PersistGate>
			</I18nextProvider>
		</Suspense>
	)
}

export default App
